
export const BASE_URL = import.meta.env.VITE_API_URL;
export const COLOR = {
    odd: '#ffffff',
    even:'#f4f4f4',
    PERCENTAGE_IN_GREEN: '#00C653',
    PERCENTAGE_IN_RED: '#C60000'
}

export const API_STATUS = {
    IDEL:'idel',
    SUCCESS:'success',
    PENDING:'pending',
    ERROR:'error'
}
export const USER_TYPE = {
    CLINICIAN:'clinician',
    USER: 'user'
}

export const TASKS_FROM_WEB = [
    'video',
    'questionnaire',
    'education',
    'exercise',
    'initialClinic',
    'message'
]
export const PATH_IMAGES = '';
export const PATH_VIDEOS = '';

export const MONTHLY_COLUMN_OPTIONS = {
        height:30,
        filter: true,
        
        setCellProps: () => ({ style: { 
            textAlign:'center',
            height:30,
            border:1,
        } }),
        setCellHeaderProps: () => ({ style:{ 
           textAlign:'center',
        //    transformOrigin:'50% 50%',
        //    transform: 'rotate(-90deg)',
            writingMode:'tb',
           border:1,
           fontSize:'11px',
           padding:'5px',
        //    height:60,
           fontWeight:'bold',
           backgroundColor:'#def1fc'
        }})
}
export const SENSOR_COLUMN_OPTIONS = {
        filter: true,
        setCellProps: () => ({ style: { 
            textAlign:'center',
            height:30,
            border:1,
           } 
        }),
        setCellHeaderProps: () => ({ style:{ 
            textAlign:'center',
            transformOrigin:'50% 50%',
            transform: 'rotate(-90deg)',
            border:1,
            fontSize:'11px',
            height:70,
            fontWeight:'bold',
            }
        })
}

export const USER_CHECK_LIST = [
    {id:1, name:'Verify Intake Questionnaire'},
    {id:2, name:'Demo Sensor placement'},
    {id:3, name:'Educational Videos'},
    {id:4, name:'Modum Max'},
    {id:5, name:'STS'},
    // {id:6, name:'TUG'},
    {id:6, name:'Exercise'},
]
export const USER_CHECK_LIST_SPANISH = [
    {id: 1, name: 'Verificar Cuestionario de Admisión'},
    {id: 2, name: 'Demostración de colocación de sensor'},
    {id: 3, name: 'Videos Educativos'},
    {id: 4, name: 'Modum Max'},
    {id: 5, name: 'STS'},
    // {id: 6, name: 'TUG'},
    {id: 6, name: 'Ejercicio'},
]

export const MONTHS = [
    {value:'01', name:'Jan'},
    {value:'02', name:'Feb'}, 
    {value:'03', name:'Mar'}, 
    {value:'04', name:'Apr'}, 
    {value:'05', name:'May'}, 
    {value:'06', name:'Jun'}, 
    {value:'07', name:'Jul'}, 
    {value:'08', name:'Aug'}, 
    {value:'09', name:'Sep'}, 
    {value:'10', name:'Oct'}, 
    {value:'11', name:'Nov'}, 
    {value:'12', name:'Dec'}];

    
export const YEARS = [2023,2024,2025,2026,2027,2028,2029,2030];
export const REQ_HEADERS = {
    "authorization": localStorage.getItem("token"),
    "Content-Type": "application/json",
}
export const USER_TOKEN = localStorage.getItem('token');
